// extracted by mini-css-extract-plugin
module.exports = {"BooksFormErrorMessage":"BooksFormErrorMessage_BooksFormErrorMessage__3gH71"};